// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeaS1fFr {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  z-index: 2000;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 2rem 1rem;
}
.J2HP87iK {
  position: relative;
  width: 100%;
  max-width: 25.875rem;
  box-sizing: border-box;
  padding: 2.5875rem 2.3rem 2.3rem;
  background: #fffdf4;
  border-radius: 2.3rem;
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.18);
  -webkit-animation: LTjc1z3e 0.3s ease;
          animation: LTjc1z3e 0.3s ease;
  overflow: visible;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}
@media (max-width: 767px) {
  .J2HP87iK {
    max-width: 90%;
    padding: 2.3rem 1.725rem 2.0125rem;
    border-radius: 2.0125rem;
  }
}
@-webkit-keyframes LTjc1z3e {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes LTjc1z3e {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
.OvPYSVbM {
  background: none;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: absolute;
  top: -0.8625rem;
  right: -1.4375rem;
  width: 4.025rem;
  height: 4.025rem;
  padding: 0;
  border: none;
  background: transparent;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  cursor: pointer;
  z-index: 2;
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}
.OvPYSVbM:hover {
  -webkit-transform: scale(1.05);
          transform: scale(1.05);
}
.OvPYSVbM:active {
  -webkit-transform: scale(0.95);
          transform: scale(0.95);
}
@media (max-width: 767px) {
  .OvPYSVbM {
    top: -0.71875rem;
    right: -1.00625rem;
    width: 3.45rem;
    height: 3.45rem;
  }
}
.wB18_7y7 {
  width: 100%;
  height: 100%;
  display: block;
  -o-object-fit: contain;
     object-fit: contain;
}
.HvSwzAXT {
  margin: 0 0 2.3rem;
  font-size: 1.725rem;
  font-weight: bold;
  color: #5e5447;
  text-align: center;
  line-height: 1.3;
}
@media (max-width: 767px) {
  .HvSwzAXT {
    font-size: 1.4375rem;
    margin-bottom: 1.725rem;
  }
}
.fZaUwFkV {
  margin-bottom: 1.15rem;
  position: relative;
  z-index: 1;
}
.fZaUwFkV:has(.PkBvn5OD) {
  z-index: 20;
}
.fZaUwFkV:last-of-type {
  margin-bottom: 1.725rem;
}
.npbYB_aD {
  position: relative;
  border: 3px solid #fbd9b9;
  border-radius: 1.725rem;
  background: #fff1db;
  overflow: hidden;
  -webkit-transition: box-shadow 0.32s cubic-bezier(0.33, 1, 0.68, 1), border-radius 0.32s cubic-bezier(0.33, 1, 0.68, 1), border-color 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  transition: box-shadow 0.32s cubic-bezier(0.33, 1, 0.68, 1), border-radius 0.32s cubic-bezier(0.33, 1, 0.68, 1), border-color 0.32s cubic-bezier(0.33, 1, 0.68, 1);
}
.npbYB_aD.PkBvn5OD {
  overflow: visible;
  border-radius: 1.725rem 1.725rem 0 0;
  border-bottom-color: transparent;
  box-shadow: 0 0.125rem 0.375rem rgba(94, 84, 71, 0.06);
}
.npbYB_aD.PkBvn5OD .IrhIZmS7 {
  grid-template-rows: 1fr;
  pointer-events: auto;
}
.npbYB_aD.PkBvn5OD .uKhqf4zw {
  border-color: #fbd9b9;
  border-width: 3px;
  border-top-color: #e8dcc8;
  box-shadow: 0 0.375rem 0.75rem rgba(94, 84, 71, 0.12);
}
.npbYB_aD.PkBvn5OD .uKhqf4zw::before {
  opacity: 1;
}
.npbYB_aD.JEybOeGd {
  opacity: 0.72;
  cursor: not-allowed;
}
._969EMhxi {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  min-width: 0;
  border: none;
  border-radius: inherit;
  background: transparent;
  z-index: 1;
  min-height: 3.45rem;
}
@media (max-width: 767px) {
  ._969EMhxi {
    min-height: 3.1625rem;
  }
}
.bKdnsQEy {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  min-width: 0;
  width: 100%;
  padding: 1.00625rem 0.575rem 1.00625rem 1.4375rem;
  border: none;
  outline: none;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 1.15rem;
  font-weight: bold;
  color: #5e5447;
  background: transparent;
  line-height: 1.4;
}
.bKdnsQEy::-webkit-input-placeholder {
  color: #5e5447;
  font-weight: bold;
  opacity: 0.88;
}
.bKdnsQEy::-moz-placeholder {
  color: #5e5447;
  font-weight: bold;
  opacity: 0.88;
}
.bKdnsQEy::placeholder {
  color: #5e5447;
  font-weight: bold;
  opacity: 0.88;
}
@media (max-width: 767px) {
  .bKdnsQEy {
    padding: 0.8625rem 0.43125rem 0.8625rem 1.15rem;
    font-size: 1.00625rem;
  }
}
.Ymu4vWVF {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  padding: 1.00625rem 0.575rem 1.00625rem 1.4375rem;
  cursor: pointer;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  outline: none;
  min-height: 3.45rem;
}
.Ymu4vWVF.Ze5UZdoN {
  cursor: not-allowed;
}
@media (max-width: 767px) {
  .Ymu4vWVF {
    padding: 0.8625rem 0.43125rem 0.8625rem 1.15rem;
    min-height: 3.1625rem;
  }
}
.nj9mfuGx {
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 1.15rem;
  font-weight: bold;
  color: #5e5447;
  width: 100%;
}
@media (max-width: 767px) {
  .nj9mfuGx {
    font-size: 1.00625rem;
  }
}
.zwv60tv4 {
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 1.15rem;
  font-weight: bold;
  color: #c9a574;
}
@media (max-width: 767px) {
  .zwv60tv4 {
    font-size: 1.00625rem;
  }
}
.TqWA51oL {
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  padding: 1.00625rem 1.29375rem 1.00625rem 0.575rem;
  background: transparent;
  border: none;
  cursor: pointer;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .TqWA51oL {
    padding: 0.8625rem 1.15rem 0.8625rem 0.43125rem;
  }
}
.VgvIGa05 {
  width: 1.15rem;
  height: 1.15rem;
  -webkit-transition: -webkit-transform 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  transition: -webkit-transform 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  transition: transform 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  transition: transform 0.32s cubic-bezier(0.33, 1, 0.68, 1), -webkit-transform 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  display: inline-block;
}
.V34fDr4G {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}
.IrhIZmS7 {
  position: absolute;
  top: 100%;
  left: -3px;
  right: -3px;
  z-index: 2;
  display: grid;
  grid-template-rows: 0fr;
  margin-top: -3px;
  -webkit-transition: grid-template-rows 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  transition: grid-template-rows 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  pointer-events: none;
}
.uKhqf4zw {
  min-height: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: #fff1db;
  border: 3px solid transparent;
  border-radius: 0 0 1.725rem 1.725rem;
  -webkit-transition: border-color 0.32s cubic-bezier(0.33, 1, 0.68, 1), box-shadow 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  transition: border-color 0.32s cubic-bezier(0.33, 1, 0.68, 1), box-shadow 0.32s cubic-bezier(0.33, 1, 0.68, 1);
  border-top: none;
}
.uKhqf4zw::before {
  content: '';
  display: block;
  width: 90%;
  height: 2px;
  background: #fbd9b9;
  opacity: 0;
  margin: 0 auto;
}
.uKhqf4zw.a1vBnoQS {
  max-height: 18.1125rem;
}
.uKhqf4zw.zaoWmaQV {
  overflow-y: auto;
}
.PkycylE_ {
  padding: 1.00625rem 0;
  cursor: pointer;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 1.15rem;
  font-weight: bold;
  color: #5e5447;
  text-align: center;
  -webkit-transition: background-color 0.2s ease, color 0.2s ease;
  transition: background-color 0.2s ease, color 0.2s ease;
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.PkycylE_:hover {
  color: #ff8100;
}
.PkycylE_.IaZIvCvG {
  color: #ff8100;
  background: #fff1db;
}
@media (max-width: 767px) {
  .PkycylE_ {
    padding: 0.8625rem 1.15rem;
    padding-left: 0.3rem;
    font-size: 1.00625rem;
    color: #5e5447;
  }
}
.OvuUhSxr {
  padding: 1.00625rem 1.4375rem;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 1.00625rem;
  font-weight: bold;
  color: #c9a574;
  text-align: center;
}
@media (max-width: 767px) {
  .OvuUhSxr {
    padding: 0.8625rem 1.15rem;
    font-size: 0.8625rem;
  }
}
.Ipquc5gU {
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  width: 100%;
  padding: 1.078125rem 1.725rem;
  background: #ff8100;
  border: none;
  border-radius: 999px;
  color: #ffffff;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 1.29375rem;
  font-weight: bold;
  cursor: pointer;
  -webkit-transition: background-color 0.2s ease, -webkit-transform 0.2s ease;
  transition: background-color 0.2s ease, -webkit-transform 0.2s ease;
  transition: background-color 0.2s ease, transform 0.2s ease;
  transition: background-color 0.2s ease, transform 0.2s ease, -webkit-transform 0.2s ease;
  min-height: 2.75rem;
  min-width: 2.75rem;
}
.Ipquc5gU:hover {
  background: #e67400;
}
.Ipquc5gU:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
@media (max-width: 767px) {
  .Ipquc5gU {
    font-size: 1.15rem;
    padding: 1.00625rem 1.15rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ServerSelectModal/ServerSelectModal.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAsBA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;ECkCA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDlCA,kBAAA;AAnBF;AAsBA;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;EACA,gCAAA;EACA,mBAAA;EACA,qBAAA;EACA,+CAAA;EACA,qCAAA;UAAA,6BAAA;EACA,iBAAA;EACA,+EAAA;AApBF;ACnBE;EAAA;ID0CE,cAAA;IACA,kCAAA;IACA,wBAAA;EAnBF;AACF;AAsBA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EApBF;EAsBA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EApBF;AACF;AAYA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EApBF;EAsBA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EApBF;AACF;AAuBA;EC0CE,gBAAA;EAEA,SAAA;EAEA,aAAA;EACA,oBAAA;ED7CA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,+CAAA;EAAA,uCAAA;EAAA,+BAAA;EAAA,4DAAA;AAlBF;AAoBE;EACE,8BAAA;UAAA,sBAAA;AAlBJ;AAqBE;EACE,8BAAA;UAAA,sBAAA;AAnBJ;AC9DE;EAAA;IDqFE,gBAAA;IACA,kBAAA;IACA,cAAA;IACA,eAAA;EAnBF;AACF;AAsBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;KAAA,mBAAA;AApBF;AAuBA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AArBF;ACpFE;EAAA;ID4GE,oBAAA;IACA,uBAAA;EApBF;AACF;AAuBA;EACE,sBAAA;EACA,kBAAA;EACA,UAAA;AArBF;AAuBE;EACE,WAAA;AArBJ;AAwBE;EACE,uBAAA;AAtBJ;AA0BA;EACE,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0KAAA;EAAA,kKAAA;AAxBF;AA6BE;EACE,iBAAA;EACA,oCAAA;EACA,gCAAA;EACA,sDAAA;AA3BJ;AAuBE;EAOI,uBAAA;EACA,oBAAA;AA3BN;AAmBE;EAYI,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qDAAA;AA5BN;AA8BM;EACE,UAAA;AA5BR;AAiCE;EACE,aAAA;EACA,mBAAA;AA/BJ;AAmCA;EACE,kBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;AAjCF;AC/IE;EAAA;IDmLE,qBAAA;EAhCF;AACF;AAmCA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,YAAA;EACA,WAAA;EACA,iDAAA;EAEA,YAAA;EACA,aAAA;EACA,+EAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;AAlCF;AAoCE;EACE,cAAA;EACA,iBAAA;EACA,aAAA;AAlCJ;AA+BE;EACE,cAAA;EACA,iBAAA;EACA,aAAA;AAlCJ;AA+BE;EACE,cAAA;EACA,iBAAA;EACA,aAAA;AAlCJ;ACvKE;EAAA;ID6ME,+CAAA;IAEA,qBAAA;EAnCF;AACF;AAsCA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,iDAAA;EAEA,eAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,aAAA;EACA,mBAAA;AArCF;AAuCE;EACE,mBAAA;AArCJ;ACzLE;EAAA;IDkOE,+CAAA;IAEA,qBAAA;EAtCF;AACF;AAyCA;EACE,+EAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAvCF;ACtME;EAAA;IDgPE,qBAAA;EAtCF;AACF;AAyCA;EACE,+EAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAvCF;ACjNE;EAAA;ID2PE,qBAAA;EAtCF;AACF;AAyCA;EC1JE,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EDuJA,kDAAA;EAEA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,sBAAA;UAAA,cAAA;AApCF;ACrOE;EAAA;ID4QE,+CAAA;EAnCF;AACF;AAuCA;EACE,cAAA;EACA,eAAA;EACA,0EAAA;EAAA,kEAAA;EAAA,0DAAA;EAAA,kHAAA;EACA,qBAAA;AArCF;AAwCA;EACE,iCAAA;UAAA,yBAAA;AAtCF;AAyCA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,2EAAA;EAAA,mEAAA;EACA,oBAAA;AAvCF;AA0CA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,sHAAA;EAAA,8GAAA;EAGA,gBAAA;AA1CF;AA4CE;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;AA1CJ;AA6CE;EACE,sBAAA;AA3CJ;AA8CE;EACE,gBAAA;AA5CJ;AAgDA;EACE,qBAAA;EACA,eAAA;EACA,+EAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,+DAAA;EAAA,uDAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;AA9CF;AAgDE;EACE,cAAA;AA9CJ;AAiDE;EACE,cAAA;EACA,mBAAA;AA/CJ;AC5SE;EAAA;ID+VE,0BAAA;IACA,oBAAA;IACA,qBAAA;IACA,cAAA;EA/CF;AACF;AAkDA;EACE,6BAAA;EACA,+EAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAhDF;AC5TE;EAAA;ID+WE,0BAAA;IACA,oBAAA;EA/CF;AACF;AAkDA;EC/QE,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;ED4QA,WAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,+EAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,2EAAA;EAAA,mEAAA;EAAA,2DAAA;EAAA,wFAAA;ECjRA,mBAAA;EACA,kBAAA;ADsOF;AA6CE;EACE,mBAAA;AA3CJ;AA8CE;EACE,8BAAA;UAAA,sBAAA;AA5CJ;AC5VE;EAAA;ID4YE,kBAAA;IACA,2BAAA;EA5CF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n@server-modal-bg: #fffdf4;\n@server-modal-text: #5e5447;\n@server-modal-orange: #ff8100;\n@server-modal-orange-dark: #e67400;\n@server-modal-input-bg: #fff1db;\n@server-modal-input-border: #fbd9b9;\n@server-modal-placeholder: #c9a574;\n@server-modal-chevron: #ff9a3d;\n@server-modal-scale: 1.15;\n@server-modal-base-width: 22.5rem;\n@server-select-radius: (1.5rem * @server-modal-scale);\n@server-select-pill-radius: ((3rem * @server-modal-scale) / 2);\n@server-select-transition: 0.32s cubic-bezier(0.33, 1, 0.68, 1);\n@server-dropdown-visible-count: 5;\n@server-dropdown-item-block-size: (\n  (0.875rem * 2 * @server-modal-scale) + (@font-size-md * @server-modal-scale * 1.4)\n);\n@server-dropdown-scroll-max-height: (@server-dropdown-item-block-size * @server-dropdown-visible-count);\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n  z-index: @z-index-modal;\n  .flex-center();\n  padding: @spacing-xl @spacing-md;\n}\n\n.modal {\n  position: relative;\n  width: 100%;\n  max-width: (@server-modal-base-width * @server-modal-scale);\n  box-sizing: border-box;\n  padding: (2.25rem * @server-modal-scale) (2rem * @server-modal-scale) (2rem * @server-modal-scale);\n  background: @server-modal-bg;\n  border-radius: (2rem * @server-modal-scale);\n  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.18);\n  animation: slideUp 0.3s ease;\n  overflow: visible;\n  font-family: @font-family-sans;\n\n  .mobile({\n    max-width: 90%;\n    padding: (2rem * @server-modal-scale) (1.5rem * @server-modal-scale) (1.75rem * @server-modal-scale);\n    border-radius: (1.75rem * @server-modal-scale);\n  });\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(1.25rem);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.closeButton {\n  .button-reset();\n  position: absolute;\n  top: (-0.75rem * @server-modal-scale);\n  right: (-1.25rem * @server-modal-scale);\n  width: (3.5rem * @server-modal-scale);\n  height: (3.5rem * @server-modal-scale);\n  padding: 0;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 2;\n  transition: transform 0.2s ease;\n\n  &:hover {\n    transform: scale(1.05);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  .mobile({\n    top: (-0.625rem * @server-modal-scale);\n    right: (-0.875rem * @server-modal-scale);\n    width: (3rem * @server-modal-scale);\n    height: (3rem * @server-modal-scale);\n  });\n}\n\n.closeButtonImg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n}\n\n.title {\n  margin: 0 0 (@spacing-xl * @server-modal-scale);\n  font-size: (@font-size-xxl * @server-modal-scale);\n  font-weight: bold;\n  color: @server-modal-text;\n  text-align: center;\n  line-height: 1.3;\n\n  .mobile({\n    font-size: (@font-size-xl * @server-modal-scale);\n    margin-bottom: (@spacing-lg * @server-modal-scale);\n  });\n}\n\n.inputGroup {\n  margin-bottom: (@spacing-md * @server-modal-scale);\n  position: relative;\n  z-index: 1;\n\n  &:has(.selectControlOpen) {\n    z-index: 20;\n  }\n\n  &:last-of-type {\n    margin-bottom: (@spacing-lg * @server-modal-scale);\n  }\n}\n\n.selectControl {\n  position: relative;\n  border: 3px solid @server-modal-input-border;\n  border-radius: @server-select-pill-radius;\n  background: @server-modal-input-bg;\n  overflow: hidden;\n  transition:\n    box-shadow @server-select-transition,\n    border-radius @server-select-transition,\n    border-color @server-select-transition;\n\n  &.selectControlOpen {\n    overflow: visible;\n    border-radius: @server-select-pill-radius @server-select-pill-radius 0 0;\n    border-bottom-color: transparent;\n    box-shadow: 0 0.125rem 0.375rem rgba(94, 84, 71, 0.06);\n\n    .dropdownCollapse {\n      grid-template-rows: 1fr;\n      pointer-events: auto;\n    }\n\n    .dropdownList {\n      border-color: @server-modal-input-border;\n      border-width: 3px;\n      border-top-color: #e8dcc8;\n      box-shadow: 0 0.375rem 0.75rem rgba(94, 84, 71, 0.12);\n\n      &::before {\n        opacity: 1;\n      }\n    }\n  }\n\n  &.selectControlDisabled {\n    opacity: 0.72;\n    cursor: not-allowed;\n  }\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  border: none;\n  border-radius: inherit;\n  background: transparent;\n  z-index: 1;\n  min-height: (3rem * @server-modal-scale);\n\n  .mobile({\n    min-height: (2.75rem * @server-modal-scale);\n  });\n}\n\n.input {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n  padding: (0.875rem * @server-modal-scale) (0.5rem * @server-modal-scale) (0.875rem * @server-modal-scale)\n    (1.25rem * @server-modal-scale);\n  border: none;\n  outline: none;\n  font-family: @font-family-sans;\n  font-size: (@font-size-md * @server-modal-scale);\n  font-weight: bold;\n  color: @server-modal-text;\n  background: transparent;\n  line-height: 1.4;\n\n  &::placeholder {\n    color: @server-modal-text;\n    font-weight: bold;\n    opacity: 0.88;\n  }\n\n  .mobile({\n    padding: (0.75rem * @server-modal-scale) (0.375rem * @server-modal-scale) (0.75rem * @server-modal-scale)\n      (1rem * @server-modal-scale);\n    font-size: (@font-size-sm * @server-modal-scale);\n  });\n}\n\n.characterInput {\n  flex: 1;\n  padding: (0.875rem * @server-modal-scale) (0.5rem * @server-modal-scale) (0.875rem * @server-modal-scale)\n    (1.25rem * @server-modal-scale);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  outline: none;\n  min-height: (3rem * @server-modal-scale);\n\n  &.characterInputDisabled {\n    cursor: not-allowed;\n  }\n\n  .mobile({\n    padding: (0.75rem * @server-modal-scale) (0.375rem * @server-modal-scale) (0.75rem * @server-modal-scale)\n      (1rem * @server-modal-scale);\n    min-height: (2.75rem * @server-modal-scale);\n  });\n}\n\n.characterName {\n  font-family: @font-family-sans;\n  font-size: (@font-size-md * @server-modal-scale);\n  font-weight: bold;\n  color: @server-modal-text;\n  width: 100%;\n\n  .mobile({\n    font-size: (@font-size-sm * @server-modal-scale);\n  });\n}\n\n.characterPlaceholder {\n  font-family: @font-family-sans;\n  font-size: (@font-size-md * @server-modal-scale);\n  font-weight: bold;\n  color: @server-modal-placeholder;\n\n  .mobile({\n    font-size: (@font-size-sm * @server-modal-scale);\n  });\n}\n\n.dropdownButton {\n  .button-reset();\n  padding: (0.875rem * @server-modal-scale) (1.125rem * @server-modal-scale) (0.875rem * @server-modal-scale)\n    (0.5rem * @server-modal-scale);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  .mobile({\n    padding: (0.75rem * @server-modal-scale) (1rem * @server-modal-scale) (0.75rem * @server-modal-scale)\n      (0.375rem * @server-modal-scale);\n  });\n}\n\n.chevron {\n  width: (1rem * @server-modal-scale);\n  height: (1rem * @server-modal-scale);\n  transition: transform @server-select-transition;\n  display: inline-block;\n}\n\n.chevronOpen {\n  transform: rotate(180deg);\n}\n\n.dropdownCollapse {\n  position: absolute;\n  top: 100%;\n  left: -3px;\n  right: -3px;\n  z-index: 2;\n  display: grid;\n  grid-template-rows: 0fr;\n  margin-top: -3px;\n  transition: grid-template-rows @server-select-transition;\n  pointer-events: none;\n}\n\n.dropdownList {\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  background-color: @server-modal-input-bg;\n  border: 3px solid transparent;\n  border-radius: 0 0 @server-select-pill-radius @server-select-pill-radius;\n  transition:\n    border-color @server-select-transition,\n    box-shadow @server-select-transition;\n  border-top: none;\n\n  &::before {\n    content: '';\n    display: block;\n    width: 90%;\n    height: 2px;\n    background: @server-modal-input-border;\n    opacity: 0;\n    margin: 0 auto;\n  }\n\n  &.dropdownListCapped {\n    max-height: @server-dropdown-scroll-max-height;\n  }\n\n  &.dropdownListScrollable {\n    overflow-y: auto;\n  }\n}\n\n.dropdownItem {\n  padding: (0.875rem * @server-modal-scale) 0;\n  cursor: pointer;\n  font-family: @font-family-sans;\n  font-size: (@font-size-md * @server-modal-scale);\n  font-weight: bold;\n  color: @server-modal-text;\n  text-align: center;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  width: 90%;\n  margin: 0 auto;\n  text-align: left;\n\n  &:hover {\n    color: @server-modal-orange;\n  }\n\n  &.dropdownItemSelected {\n    color: @server-modal-orange;\n    background: #fff1db;\n  }\n\n  .mobile({\n    padding: (0.75rem * @server-modal-scale) (1rem * @server-modal-scale);\n    padding-left: 0.3rem;\n    font-size: (@font-size-sm * @server-modal-scale);\n    color: @server-modal-text;\n  });\n}\n\n.dropdownItemEmpty {\n  padding: (0.875rem * @server-modal-scale) (1.25rem * @server-modal-scale);\n  font-family: @font-family-sans;\n  font-size: (@font-size-sm * @server-modal-scale);\n  font-weight: bold;\n  color: @server-modal-placeholder;\n  text-align: center;\n\n  .mobile({\n    padding: (0.75rem * @server-modal-scale) (1rem * @server-modal-scale);\n    font-size: (@font-size-xs * @server-modal-scale);\n  });\n}\n\n.confirmButton {\n  .button-reset();\n  width: 100%;\n  padding: (0.9375rem * @server-modal-scale) (@spacing-lg * @server-modal-scale);\n  background: @server-modal-orange;\n  border: none;\n  border-radius: 999px;\n  color: @white;\n  font-family: @font-family-sans;\n  font-size: (@font-size-lg * @server-modal-scale);\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n  .touch-friendly();\n\n  &:hover {\n    background: @server-modal-orange-dark;\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  .mobile({\n    font-size: (@font-size-md * @server-modal-scale);\n    padding: (0.875rem * @server-modal-scale) (@spacing-md * @server-modal-scale);\n  });\n}\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n// 可滚动弹窗蒙版：背景 fixed 铺满视口，内容区单独滚动，避免移动端滑出未覆盖区域\n.modalOverlayBackdrop(@bg: rgba(0, 0, 0, 0.55)) {\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n\n  &::before {\n    content: '';\n    position: fixed;\n    inset: 0;\n    background: @bg;\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    z-index: -1;\n    pointer-events: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `LeaS1fFr`,
	"modal": `J2HP87iK`,
	"slideUp": `LTjc1z3e`,
	"closeButton": `OvPYSVbM`,
	"closeButtonImg": `wB18_7y7`,
	"title": `HvSwzAXT`,
	"inputGroup": `fZaUwFkV`,
	"selectControlOpen": `PkBvn5OD`,
	"selectControl": `npbYB_aD`,
	"dropdownCollapse": `IrhIZmS7`,
	"dropdownList": `uKhqf4zw`,
	"selectControlDisabled": `JEybOeGd`,
	"inputWrapper": `_969EMhxi`,
	"input": `bKdnsQEy`,
	"characterInput": `Ymu4vWVF`,
	"characterInputDisabled": `Ze5UZdoN`,
	"characterName": `nj9mfuGx`,
	"characterPlaceholder": `zwv60tv4`,
	"dropdownButton": `TqWA51oL`,
	"chevron": `VgvIGa05`,
	"chevronOpen": `V34fDr4G`,
	"dropdownListCapped": `a1vBnoQS`,
	"dropdownListScrollable": `zaoWmaQV`,
	"dropdownItem": `PkycylE_`,
	"dropdownItemSelected": `IaZIvCvG`,
	"dropdownItemEmpty": `OvuUhSxr`,
	"confirmButton": `Ipquc5gU`
};
export default ___CSS_LOADER_EXPORT___;
